export const formatDaysValidity = (days: number[]): string => {
  const dayLabels = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];

  return days
    .sort((a, b) => a - b)
    .map((day) => dayLabels[day - 1])
    .join(", ");
};
const fmtLocal = new Intl.DateTimeFormat("fr-FR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

const fmtUTC = new Intl.DateTimeFormat("fr-FR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: "UTC",
});

export function formatDDMMYYYY(
  value: string | number | Date | null | undefined,
  opts?: { utc?: boolean }
) {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);

  if (isNaN(d.getTime())) return "";
  return (opts?.utc ? fmtUTC : fmtLocal).format(d);
}
